import * as t from 'io-ts';
import { DateFromISOString } from 'io-ts-types';
import { UUID } from '@thingos/io-ts-shared';
export const BatchCreationRequest = t.type({
    templateId: UUID,
    customer: t.string,
    amount: t.number,
    purposeNotes: t.string,
});
export const GetBatchesRequest = t.type({
    templateId: UUID,
});
export const BatchInfo = t.type({
    id: UUID,
    templateName: t.string,
    customer: t.string,
    amount: t.number,
    purposeNotes: t.string,
    date: DateFromISOString,
});
export const BatchDeletionRequest = t.type({
    batchId: UUID,
});
export const BatchCSVRequest = t.type({
    batchId: UUID,
});
export const GetBatchesResponse = t.array(BatchInfo);
//# sourceMappingURL=batches.js.map